function timestampOf(value) {
  const timestamp = new Date(value || 0).getTime();
  return Number.isFinite(timestamp) ? timestamp : 0;
}

function buildSupportTimeline(messages) {
  const timeline = [];

  (Array.isArray(messages) ? messages : []).forEach((message, messageIndex) => {
    timeline.push({
      id: `message-${message.id || messageIndex}`,
      messageId: message.id,
      type: 'user',
      content: message.content,
      createdAt: message.createdAt,
      sortTime: timestampOf(message.createdAt),
      stableOrder: messageIndex * 1000,
    });

    const replies = Array.isArray(message.replies) ? message.replies : [];
    replies.forEach((reply, replyIndex) => {
      timeline.push({
        id: `reply-${reply.id || `${message.id || messageIndex}-${replyIndex}`}`,
        messageId: message.id,
        replyId: reply.id,
        type: 'admin',
        content: reply.content,
        createdAt: reply.createdAt,
        sortTime: timestampOf(reply.createdAt),
        stableOrder: messageIndex * 1000 + replyIndex + 1,
      });
    });

    if (message.reply && replies.length === 0) {
      const createdAt = message.replyCreatedAt || message.updatedAt || message.createdAt;
      timeline.push({
        id: `legacy-reply-${message.id || messageIndex}`,
        messageId: message.id,
        type: 'admin',
        content: message.reply,
        createdAt,
        sortTime: timestampOf(createdAt),
        stableOrder: messageIndex * 1000 + 1,
      });
    }
  });

  const latestReplyByMessage = new Map();
  timeline.forEach(item => {
    if (item.type !== 'admin') return;
    const current = latestReplyByMessage.get(item.messageId);
    if (!current || item.sortTime >= current.sortTime) latestReplyByMessage.set(item.messageId, item);
  });
  latestReplyByMessage.forEach(item => { item.isLatestReply = true; });

  return timeline.sort((a, b) => a.sortTime - b.sortTime || a.stableOrder - b.stableOrder);
}

export { buildSupportTimeline };
